<template>
  <div class="h-full flex flex-col p-6 max-w-7xl mx-auto">
    <div class="mb-6">
      <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight whitespace-nowrap">
        Pipelines
      </h1>
      <p class="text-sm text-slate-500 mt-1">Edit your organization's pipelines.</p>
    </div>

    <div class="border-b border-slate-200 mb-6 shrink-0">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <RouterLink
          :to="{ name: 'EditNewLeadsPipeline' }"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
          exact-active-class="border-blue-600 text-blue-600"
          inactive-class="border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
        >
          New Leads
        </RouterLink>

        <RouterLink
          :to="{ name: 'EditPendingQuotesPipeline' }"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
          exact-active-class="border-blue-600 text-blue-600"
          inactive-class="border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
        >
          Pending Quotes
        </RouterLink>

        <RouterLink
          :to="{ name: 'EditPendingJobsPipeline' }"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
          exact-active-class="border-blue-600 text-blue-600"
          inactive-class="border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
        >
          Pending Jobs
        </RouterLink>
      </nav>
    </div>

    <div class="flex-1 min-h-0 flex flex-col">
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import { RouterLink, RouterView } from 'vue-router'
</script>
